import React, { Component } from "react";
import styled from "styled-components";

class ContentWrapper extends Component {
  // componentDidMount(prevProps) {
  //   window.scrollTo(0, 0);
  // }

  render() {
    return <Wrapper>{this.props.children}</Wrapper>;
  }
}

const Wrapper = styled.div`
  width: 960px;
  padding: 0 20px;
  margin: 0 auto;
  display: block;
  justify-content: space-between;
  @media only screen and (max-width: 980px) {
    width: 100%;
    padding: 60px 0 0 0;
    margin: 0;
    display: block;
  }
`;

export default ContentWrapper;



// WEBPACK FOOTER //
// ./src/components/layout/ContentWrapper.js